import { Component, Input } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';


@Component({
  selector: 'app-ssimdate-errors',
  templateUrl: './ssimdate-errors.component.html',
  styleUrls: ['./ssimdate-errors.component.scss']
})
export class SSIMDateErrorsComponent {

  @Input() form: FormGroup;
  @Input() controlName: string;
  @Input() referenceKey: string;
  @Input() required = false;
  @Input() interval = false;
  @Input() item: string;
  @Input() mustBeEmpty: false;
  @Input() onlyIcon = false;
  // @Input() outOfSeason = false;

  control: AbstractControl;

  constructor() { }

  getControl(): AbstractControl {
    return this.form.get(this.controlName);
  }

}
